import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { TASK_STATUS_CONFIG } from "@components/tasks/TaskStatusSelect/taskStatus.constants";
import { TaskStatus as TaskStatusEnum } from "@common/types/task";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskStatus: React.FC<Props> = ({ log }) => {
    const newStatus =
        (log.diff.find((d) => d.field === "status")?.after
            ?.value as TaskStatusEnum) ?? "";

    return (
        <>
            <span className={styles.chatTaskMessage}>
                changed the status to&nbsp;
                <strong>
                    {TASK_STATUS_CONFIG[newStatus as TaskStatusEnum].tooltip}
                </strong>
            </span>
        </>
    );
};
